import LocationUpdateForm from "./location-update-form";


export default LocationUpdateForm;